import React, { useState, useEffect } from 'react';
import CircularProgress from '@mui/material/CircularProgress';

import './mobile-app-download-style.scss';

import Button from '@src/componentsNew/Buttons/Button';
import Typography from '@src/componentsNew/Typography/Typography';

import { handleDeepLink } from '@src/utils/deepLink';

interface IProps {
  deepLink: string;
  infoText: string;
}

const MobileAppDownload = ({ deepLink, infoText }: IProps) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleClickViewOnAppButton = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.persist();

    setIsLoading(true);
    handleDeepLink(deepLink);
  };

  useEffect(() => {
    let timeout;

    if (isLoading) {
      timeout = setTimeout(() => {
        setIsLoading(false);
      }, 10000);
    }

    const onPageHide = () => {
      clearTimeout(timeout);
      setIsLoading(false);
    };

    window.addEventListener('pagehide', onPageHide);

    return () => {
      clearTimeout(timeout);
      window.removeEventListener('pagehide', onPageHide);
    };
  }, [isLoading]);

  return (
    <div id="mobile-app-download-wrapper" className={isLoading ? 'loading' : ''}>
      {isLoading ? (
        <>
          <CircularProgress color="inherit" />

          <Typography variant="subtitle2" component="p" style={{ color: '#212121' }}>
            Launching Maccaron App...
          </Typography>
        </>
      ) : (
        <>
          <Typography cName="app-text" variant="subtitle2" component="p" style={{ color: '#212121' }}>
            {infoText}
          </Typography>

          <Button size="medium" cName="view-on-app-btn" variant="contained" onClick={handleClickViewOnAppButton}>
            View On App
          </Button>
        </>
      )}
    </div>
  );
};

export default MobileAppDownload;
